export var formAddBusiness = {
    ownerName: "",
    ownerIdNumber: "",
    propertyTypeId: "",
    businessShift: "",
    sameAddress: false,
    Province: "",
    Town: "",
    Sector: "",
    typeConstruction: "",
    propertyAddress: "",
    coverageNotes: "",
    ownedProperty: false,
    rentProperty: false,
    buildingValue: "",
    merchandiseValue: "",
    furnitureValue: "",
    totalInsuredValue: "",
    insuredProperty: "",
    damageBackup: "",
};
export var propertyTypeList = [
    {
        id: "1",
        name: "Comercial",
        value: "1",
    },
    {
        id: "2",
        name: "Servicios",
        value: "2",
    },
];
export var typeConstructionList = [
    {
        id: "3",
        name: "1ra. Clase",
        value: "3",
    },
    {
        id: "2",
        name: "1ra. Clase superior",
        value: "2",
    },
    {
        id: "1",
        name: "Superior",
        value: "1",
    },
];
export var businessShiftList = [
    { id: "1", name: "Cafeterías", value: "1" },
    { id: "2", name: "Centro de convenciones y eventos", value: "2" },
    { id: "3", name: "Centros comerciales y plazas", value: "3" },
    { id: "4", name: "Centros de videojuegos", value: "4" },
    { id: "5", name: "Courier y envío de paquetes", value: "5" },
    { id: "6", name: "Dealer y concesionarios de vehículos", value: "6" },
    { id: "7", name: "Distribuidora de huevos", value: "7" },
    { id: "8", name: "Emisoras de radio y televisión", value: "8" },
    { id: "9", name: "Empresa de limpieza y fumigación", value: "9" },
    { id: "10", name: "Estudio fotográfico y de videos", value: "10" },
    { id: "11", name: "Fábrica de aparatos y artículos musicales", value: "11" },
    { id: "12", name: "Fantasías y accesorios (bisutería)", value: "12" },
    {
        id: "13",
        name: "Farmacia, tienda naturista y boticas en general",
        value: "13",
    },
    { id: "73", name: "Ferreterías a pequeña escala", value: "73" },
    { id: "14", name: "Floristería y vivero", value: "14" },
    { id: "15", name: "Galería de arte", value: "15" },
    { id: "16", name: "Gimnasio", value: "16" },
    { id: "17", name: "Heladerías", value: "17" },
    { id: "18", name: "Hoteles en la ciudad", value: "18" },
    { id: "19", name: "Joyería", value: "19" },
    { id: "20", name: "Juguetería", value: "20" },
    { id: "21", name: "Lavanderías y tintorerías", value: "21" },
    { id: "22", name: "Museos", value: "22" },
    { id: "23", name: "Óptica", value: "23" },
    { id: "24", name: "Organizador de eventos", value: "24" },
    { id: "59", name: "Otros", value: "59" },
    { id: "25", name: "Panadería y repostería", value: "25" },
    { id: "26", name: "Restaurantes y fondas", value: "26" },
    { id: "27", name: "Sala de cine y teatros", value: "27" },
    { id: "28", name: "Salón de belleza y spa", value: "28" },
    { id: "29", name: "Sederías y misceláneos", value: "29" },
    { id: "30", name: "Supermercado", value: "30" },
    { id: "31", name: "Tienda de artículos de cumpleaños", value: "31" },
    { id: "32", name: "Tienda de aparatos y artículos musicales", value: "32" },
    { id: "33", name: "Tienda de artesanía", value: "33" },
    {
        id: "34",
        name: "Tienda de artículos para decoración de interiores",
        value: "34",
    },
    { id: "35", name: "Tienda de artículos deportivos", value: "35" },
    { id: "36", name: "Tienda de artículos eléctricos", value: "36" },
    { id: "37", name: "Tienda de artículos para iluminación", value: "37" },
    { id: "38", name: "Tienda de artículos religiosos", value: "38" },
    { id: "39", name: "Tienda de bicicletas y repuestos", value: "39" },
    { id: "40", name: "Tienda de calzado", value: "40" },
    { id: "41", name: "Tienda de equipos electrónicos", value: "41" },
    { id: "42", name: "Tienda de frutas y vegetales", value: "42" },
    { id: "43", name: "Tienda de repuestos para motores", value: "43" },
    { id: "44", name: "Tienda de ropa y boutique", value: "44" },
    { id: "45", name: "Venta de alimentos para animales", value: "45" },
    { id: "46", name: "Venta de artículos para higiene personal", value: "46" },
    { id: "47", name: "Venta de cerámica", value: "47" },
    { id: "48", name: "Venta de cosméticos", value: "48" },
    { id: "49", name: "Venta de cristalería", value: "49" },
    { id: "50", name: "Venta de dulces y chocolates", value: "50" },
    { id: "51", name: "Venta de equipos pesados", value: "51" },
    { id: "52", name: "Venta de letreros", value: "52" },
    {
        id: "53",
        name: "Venta de material gastable para servicios médicos",
        value: "53",
    },
    { id: "54", name: "Venta de motocicletas", value: "54" },
    { id: "55", name: "Venta de productos ortopédicos", value: "55" },
    { id: "56", name: "Venta de revistas y periódicos", value: "56" },
    { id: "57", name: "Venta y alquiler de videos", value: "57" },
    { id: "58", name: "Veterinaria", value: "58" },
];
export var businessShiftServicesList = [
    { id: "60", name: "Biblioteca", value: "60" },
    { id: "61", name: "Centro de internet y de llamadas", value: "61" },
    { id: "62", name: "Clínicas y hospitales", value: "62" },
    { id: "63", name: "Clubes sociales y recreativos", value: "63" },
    { id: "64", name: "Consultorio médico", value: "64" },
    { id: "65", name: "Consultorio odontológico", value: "65" },
    { id: "66", name: "Escuela de deportes", value: "66" },
    {
        id: "67",
        name: "Escuelas, colegios, universidades, academias y centros educativos",
        value: "67",
    },
    { id: "68", name: "Iglesias y templos religiosos", value: "68" },
    { id: "69", name: "Oficinas", value: "69" },
    { id: "72", name: "Otros", value: "72" },
    { id: "70", name: "Parque de diversiones", value: "70" },
    { id: "71", name: "Tienda de equipos para piscina y jacuzzis", value: "71" },
];
export var FormsBusinessDTO = {
    section1Title: "Datos del negocio",
    section2Title: "Ubicación de la propiedad",
    section3Title: "Valores asegurados",
    disablePropertyType: true,
    showBtnCalcRate: true,
    ProvinceList: [],
    TownList: [],
    SectorList: [],
    propertyTypeList: propertyTypeList,
    businessShiftList: [],
    typeConstructionList: typeConstructionList,
    damageBackup: "",
    insuredProperty: "",
    onNext: function () { },
};
